import './index.css';

const iOS_URL = 'https://apps.apple.com/cn/app/id6504193450';
const ANDROID_URL = 'https://walkdare.cn/resource/kuaibei/apks/kuaibei-recent.apk';

const FEATURES = [
    {
        title: '遗忘曲线智能复习',
        desc: '依据遗忘曲线原理分析学习情况，在恰当的时间提醒复习，记得更牢、忘得更慢。',
    },
    {
        title: '个性化学习计划',
        desc: '智能分析你的学习状况，量身定制复习计划，让每个知识点都得到及时巩固。',
    },
    {
        title: '系统化中医知识库',
        desc: '全面深入的中医知识点与经典内容，系统学习、随时查阅，夯实根基。',
    },
    {
        title: '互动学习传承文化',
        desc: '丰富的互动学习方式，让用户在学习的同时感受中医的博大精深与独特魅力。',
    },
];

const SHOTS = [
    {src: 'shot-1.png', alt: '快背中医 App 截图一'},
    {src: 'shot-2.png', alt: '快背中医 App 截图二'},
    {src: 'shot-3.png', alt: '快背中医 App 截图三'},
];

export default function Home() {
    return (
        <div className="home">
            <section className="home-hero">
                <img className="home-icon" src={`${process.env.PUBLIC_URL}/images/app-icon.png`} alt="快背中医 App 图标"/>
                <div className="home-hero-text">
                    <h1 className="home-brand">快背中医</h1>
                    <p className="home-slogan">快速记忆中医知识</p>
                    <p className="home-sub">专注中医知识学习的智能工具，运用遗忘曲线原理，为你量身定制学习计划。</p>
                    <div className="home-downloads">
                        <a className="home-download home-download-ios" href={iOS_URL} target="_blank" rel="noreferrer">
                            App Store 下载
                        </a>
                        <a className="home-download home-download-android" href={ANDROID_URL} target="_blank" rel="noreferrer">
                            Android 下载
                        </a>
                    </div>
                </div>
            </section>

            <section className="home-features">
                <h2 className="home-section-title">为什么选择快背中医</h2>
                <div className="home-feature-grid">
                    {FEATURES.map((feature) => (
                        <div className="home-feature" key={feature.title}>
                            <h3>{feature.title}</h3>
                            <p>{feature.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="home-shots">
                <h2 className="home-section-title">App 预览</h2>
                <div className="home-shot-list">
                    {SHOTS.map((shot) => (
                        <img className="home-shot" key={shot.src} src={`${process.env.PUBLIC_URL}/images/${shot.src}`} alt={shot.alt}/>
                    ))}
                </div>
            </section>

            <section className="home-about">
                <h2 className="home-section-title">关于快背中医</h2>
                <p>
                    快背中医是一款专注于中医知识学习的智能工具。它提供全面且深入的中医相关知识点，帮助用户系统地学习和记忆。
                    通过运用遗忘曲线原理，App 能智能分析用户的学习情况，为用户量身定制学习计划，确保知识得到及时巩固与复习。
                    此外，App 还致力于传承中医文化，通过丰富的中医知识库和互动学习方式，让用户在学习的同时感受到中医的博大精深与独特魅力。
                </p>
                <p className="home-disclaimer">
                    使用此应用程序时请注意，本应用的所有信息仅供参考，不能作为诊断、用药的使用和根据，不能替代医生和其他医务人员的建议。
                    如遇身体不适，请及时就医。
                </p>
            </section>

            <footer className="home-footer">
                <p>重庆沃可达科技有限公司</p>
                <p>© 2026 快背中医</p>
                <p className="home-icp">
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">渝ICP备2023012713号-2</a>
                </p>
            </footer>
        </div>
    );
}
